import React from 'react'
import { ProductWithRelations } from 'Types';
import { useMenuContext } from 'context/MenuContext';
import Link from 'next/link';
import classnames from 'classnames';
import { getFormatedPrice } from 'helpers';
import { getHighAndLowestPrice } from 'helpers/productHelpers';

interface Props {
  item: ProductWithRelations;
}

const MenuList: React.FC <Props> = ({item}) => {
  const { slug: storeSlug, currency_symbol } = useMenuContext();

  const price = getHighAndLowestPrice(item);

  return (
    <Link
    href={`/${storeSlug}/${item.slug}`}
    className="py-4 flex justify-between border-b border-gray-200"
  >
    <span className="text-lg">
      {item.title}
    </span>
    <div className="flex flex-wrap gap-x-2 items-center justify-end">
      <span
        className={classnames('font-light text-lg', {
          'line-through text-gray-500':
            item.price_promotional,
        })}
      >
        {price.uniquePrice ? (
          getFormatedPrice(item.price, currency_symbol)
        ) : (
          <span>
            {getFormatedPrice(price.lowestPrice || 0, currency_symbol)} -{' '}
            {getFormatedPrice(price.highestPrice || 0, currency_symbol)}
          </span>
        )}
      </span>
      {item.price_promotional && (
        <span className="font-light text-lg">
          {price.uniquePrice ? (
            getFormatedPrice(item.price_promotional, currency_symbol)
          ) : (
            <span>
              {getFormatedPrice(
                price.lowestPromotionalPrice || 0,
                currency_symbol
              )}{' '}
              -{' '}
              {getFormatedPrice(
                price.highestPromotionalPrice || 0,
                currency_symbol
              )}
            </span>
          )}
        </span>
      )}
    </div>
  </Link>
  )
}

export default MenuList